import { ref } from 'vue'
import { contactsService, quotesService } from '../../services'

/**
 * Références du même métier, cherchées par l'IA quand on appuie sur le
 * bouton — jamais d'office : chaque recherche sollicite un modèle payant et
 * prend une ou deux secondes.
 */
export function useSimilarCompaniesAi() {
  const companies = ref([])
  const loading = ref(false)
  const searched = ref(false)
  const error = ref(null)

  const search = async (fetcher) => {
    if (loading.value) return
    loading.value = true
    error.value = null
    try {
      companies.value = (await fetcher())?.companies || []
      searched.value = true
    } catch (err) {
      error.value = err.message || 'La recherche n’a pas abouti. Réessayez dans un instant.'
    } finally {
      loading.value = false
    }
  }

  const searchForContact = (email, siret) => search(() => contactsService.findSimilarCompaniesAi(email, siret))
  const searchForQuote = (quoteId) => search(() => quotesService.findSimilarCompaniesAi(quoteId))

  return { companies, loading, searched, error, searchForContact, searchForQuote }
}
